module.exports = __webpack_public_path__ + "img/62.3.TP.956896a6.png";